export const DefaultColorTheme = {
  primary: "#D9EAFF",
  primaryForeground: "#ffffff",
  primaryHover: "#40658b",

  secondary: "#ffffff",
  secondaryForeground: "#D9EAFF",
  secondaryHover: "#f3f4f6",
  secondaryLightForeground: "#D9EAFF",

  tertiary: "#ffffff",
  tertiaryForeground: "#017e9b",
  tertiaryHover: "#f3f4f6",

  background: "#ffffff",
  foreground: "#D9EAFF",

  input: "#ffffff",
  border: "#DCDCDC",

  text: {
    primaryText: "#1A1A1A",
    secondaryText: "#888888",
    tertiaryText: "#ffffff",
    primaryLightText: "#1E1E1E",
    actionTextColor: "#D9EAFF",
    actionTextColorSecondary: "#ffffff",
    errorText: "#DA272E",

    black200: "#1A1A1A",
    black300: "#333333",
    black900: "#000000",

    gray200: "#595959",
    gray300: "#717171",
    gray400: "#ACACAC",
    gray500: "#c9c9c9",
    gray900: "#808080",

    white900: "#ffffff",
  },
  state: {
    success: "#16A34A",
    warning: "#EA670C",
    error: "#DA272E",
  },
  button: {
    primaryBackground: "#D9EAFF",
    primaryText: "#ffffff",
  },
  pageBackground: {
    primary: "#ffffff",
    secondary: "#f7f7f7",
  },
  font: {
    primary: "sans-seri",
    secondary: "sans-seri",
    fallback: "sans-serif",
  },
  floatCard: {
    background: "#16A34A",
    text: "#ffffff",
    border: "#16A34A",
  },
};
